import { BaseComponent } from '../../../components/BaseComponent';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import styled from 'styled-components';
import { createStructuredSelector } from 'reselect';
import { Route, Switch, withRouter } from 'react-router-dom';
import { PageHeader } from '../../../components/PageHeader';
import { ChevronRight } from '../../../components/Icon';
import { EmailHistoryOverview } from './overview';

const Container = styled.div``;

const STATE = {};

class EmailHistoryBoardPageComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  render() {
    return (
      <Container>
        <PageHeader
          title={<>{this.lbl('email_history.overview.title')}</>}
          breadCrumbs={
            <>
              <a href="/">Vindat</a>
              <ChevronRight />
              {this.lbl('email_history.overview.title')}
            </>
          }
        />

        <Switch>
          <Route render={component => <EmailHistoryOverview />} />
        </Switch>
      </Container>
    );
  }
}

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const EmailHistoryBoardPage = compose(
  withConnect,
  withRouter,
)(EmailHistoryBoardPageComp);
